import { useLocation } from "react-router-dom";

interface UseBackUrl {
  currentUrl: string;
  backUrl: string | null;
}

export const useBackUrl = (): UseBackUrl => {
  const { pathname, search, state } = useLocation();
  return {
    currentUrl: pathname + search,
    backUrl: state?.backUrl ?? null,
  };
};
